import { MinzeElement, Attrs } from 'minze'
import { Locale } from '../../modules/locale'
import { FavoriteItemType } from '../../modules/auth'

Locale.getInstance().registerKeySet('fr', 'lvcAccountFavoritesEmpty', {
  noFavoriteContributorsTitle: "Vous n'avez pas d'artiste favori.",
  noFavoriteContributorsDescription: 'Pour ajouter un artiste à votre liste, cliquez sur Favoris.',
  noFavoriteEventsTitle: "Vous n'avez pas d'événements favoris.",
  noFavoriteEventsDescription: 'Pour ajouter un événement à votre liste, cliquez sur Favoris.',
  noFavoriteEventSeriesTitle: "Vous n'avez pas de festival ou de série favoris.",
  noFavoriteEventSeriesDescription:
    'Pour ajouter un festival ou une série à votre liste de favoris, cliquez sur Favoris.',
  noFavoriteExhibitionsTitle: "Vous n'avez pas d'expositions favorites.",
  noFavoriteExhibitionsDescription:
    'Pour ajouter une exposition à votre liste, cliquez sur Favoris.',
  noFavoritePlacesTitle: "Vous n'avez pas de lieu favori.",
  noFavoritePlacesDescription: 'Pour ajouter un lieu à votre liste, cliquez sur Favoris.',
})

Locale.getInstance().registerKeySet('en', 'lvcAccountFavoritesEmpty', {
  noFavoriteContributorsTitle: 'You have no favorite artists.',
  noFavoriteContributorsDescription: 'Click on Favorite to add an artist to your list.',
  noFavoriteEventsTitle: 'You have no favorite events.',
  noFavoriteEventsDescription: 'Click on Favorite to add an event to your list.',
  noFavoriteEventSeriesTitle: 'You have no favorite festivals or series.',
  noFavoriteEventSeriesDescription: 'Click on Favorite to add a festival or serie to your list.',
  noFavoriteExhibitionsTitle: 'You have no favorite exhibitions.',
  noFavoriteExhibitionsDescription: 'Click on Favorite to add an exhibition to your list.',
  noFavoritePlacesTitle: 'You have no favorite places.',
  noFavoritePlacesDescription: 'Click on Favorite to add a place to your list.',
})

export interface LvcAccountFavoritesEmpty {
  type: string
}

export class LvcAccountFavoritesEmpty extends MinzeElement {
  attrs: Attrs = ['type']

  getNoFavoriteText = (type: string, textName: string) => {
    switch (type) {
      case FavoriteItemType.Contributors:
        return Locale.getKey('lvcAccountFavoritesEmpty.noFavoriteContributors' + textName)
      case FavoriteItemType.Event:
        return Locale.getKey('lvcAccountFavoritesEmpty.noFavoriteEvents' + textName)
      case FavoriteItemType.EventSeries:
        return Locale.getKey('lvcAccountFavoritesEmpty.noFavoriteEventSeries' + textName)
      case FavoriteItemType.Exhibition:
        return Locale.getKey('lvcAccountFavoritesEmpty.noFavoriteExhibitions' + textName)
      case FavoriteItemType.Places:
        return Locale.getKey('lvcAccountFavoritesEmpty.noFavoritePlaces' + textName)
      default:
        return ''
    }
  }

  html = () => `
    <div class="account-favorites-empty">
      <div class="account-favorites-empty-content">
        <h2 class="account-favorites-empty-title">${this.getNoFavoriteText(this.type, 'Title')}</h2>
      </div>
      <div class="account-favorites-empty-charlie">
        <lvc-charlie-hands-together-full-body width="100%" height="auto"></lvc-charlie-hands-together-full-body>
      </div>
    </div>
  `

  css = () => `
    :host {}

    .account-favorites-empty {
      display: flex;
      flex-direction: column;
    }

    .account-favorites-empty-content {}

    .account-favorites-empty-title {
      margin: 0;
      color: #1E007D;
      font-size: 1.625em;
      font-weight: 800;
      line-height: 1.1em;
    }

    .account-favorites-empty-charlie {}
    
    @media screen and (max-width: 991px) {
      
    }

    @media only screen and (min-width: 992px) {
      .account-favorites-empty {
        flex-direction: row;
        gap: 40px;
      }

      .account-favorites-empty-content {
        max-width: 400px;
        order: 2;
      }

      .account-favorites-empty-title {
        margin-top: 20px;
        font-size: 2.5em;
        line-height: 1.1em;
      }

      .account-favorites-empty-charlie {
        max-width: 240px;
        order: 1;
      }
    }
  `
}
